import React, { Fragment, useRef } from 'react'
import injectStyles from 'react-jss'
import ArrowRight from 'Components/Icons/ArrowRight'
import { Motion, spring } from 'react-motion'
import classNames from 'classnames'
import { useOnScrollHook } from 'Utils/Elements'

const closedX = 48
const openX = 226

const styles = {
  parentContainer: {
    position: 'relative',
  },
  container: {
    lineHeight: '48px',
    width: 220,
    position: 'absolute',
    top: 0,
    left: 0,
    minHeight: 200,
    zIndex: 1,
    color: '#8A96A0',
    fontSize: 14,
    backgroundColor: 'white',
    height: '100vh',
    '@global a': {
      color: 'inherit',
      fontSize: 14,
    },
  },
  contentWrapperExpanded: {
    paddingLeft: openX,
  },
  contentWrapperShrunk: {
    paddingLeft: closedX,
  },
  arrowContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
  },
  arrowInnerContainer: {
    position: 'absolute',
    top: '50%',
    right: 0,
    marginTop: -(12 + 5),
    opacity: 0.5,
    zIndex: 10,
    paddingTop: 10,
    width: 10,
    height: 24,
    cursor: 'pointer',
    paddingBottom: 10,
    boxSizing: 'content-box',
  },
  arrow: {
    position: 'relative',
    left: -7,
  },
}

const DashboardSidebar = ({ children, classes, open, onToggle, content }) => {
  const parentContainerRef = useRef(null)
  const markerRef = useRef(null)
  const containerRef = useRef(null)

  const positionNav = () => {
    const { left } = parentContainerRef.current.getBoundingClientRect()
    const { top } = markerRef.current.getBoundingClientRect()

    if (top >= 0) {
      containerRef.current.style.position = 'absolute'
      containerRef.current.style.top = null
      containerRef.current.style.left = null
    } else {
      containerRef.current.style.position = 'fixed'
      containerRef.current.style.top = '0'
      containerRef.current.style.left = `${left}px`
    }
  }

  useOnScrollHook(positionNav)

  return (
    <div className={classes.parentContainer} ref={parentContainerRef}>
      <Motion
        defaultStyle={{ factor: open ? 0 : 1 }}
        style={{ factor: spring(open ? 0 : 1) }}
      >
        {({ factor }) => (
          <Fragment>
            <div ref={markerRef} />
            <div
              className={classes.container}
              style={{
                transform: `translate3d(-${(openX - closedX) *
                  factor}px, 0, 10px)`,
                paddingLeft: '30px',
              }}
              ref={containerRef}
            >
              <div className={classes.arrowContainer} onMouseUp={onToggle}>
                <div className={classes.arrowInnerContainer}>
                  <ArrowRight
                    className={classes.arrow}
                    style={{
                      transform: `rotateY(${180 * (1 - factor)}deg)`,
                    }}
                  />
                </div>
              </div>
              <div>{children}</div>
            </div>
          </Fragment>
        )}
      </Motion>
      <div
        className={classNames({
          [classes.contentWrapper]: true,
          [classes.contentWrapperExpanded]: open,
          [classes.contentWrapperShrunk]: !open,
        })}
      >
        {content}
      </div>
    </div>
  )
}

export default injectStyles(styles)(DashboardSidebar)
